var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHpElement05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1444,
    viewBox: "0 0 1920 1444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3369.93 7.59524C1762.65 521.341 1331.36 1136.25 490.48 881.18C-182.221 677.12 -1408.84 1129.44 -1938.06 1381.11",
    stroke: "url(#paint0_linear_1229_42283)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3372.58 7.31581C1750.69 485.528 1274.74 1097.52 470.962 816.592C-172.059 591.847 -1414.96 1017.88 -1956.04 1259",
    stroke: "url(#paint1_linear_1229_42283)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3369.17 6.80375C1733 439.698 1202.73 1047.54 446.925 734.108C-157.721 483.361 -1417.9 875.825 -1972.41 1103.4",
    stroke: "url(#paint2_linear_1229_42283)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3359.4 7.37386C1715.08 400.271 1139.5 1003.03 426.772 662.47C-143.409 390.025 -1415.26 752.678 -1979.91 968.06",
    stroke: "url(#paint3_linear_1229_42283)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3381.35 2.38113C1734.28 374.076 1135.62 973.627 445.995 619.249C-105.704 335.747 -1382.47 682.533 -1951.89 891.363",
    stroke: "url(#paint4_linear_1229_42283)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3384.89 2.39002C1735.49 335.529 1096.43 928.4 449.267 549.826C-68.4649 246.966 -1352.03 564.791 -1929.1 761.561",
    stroke: "url(#paint5_linear_1229_42283)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3381.91 1.49929C1734.28 285.581 1046.61 868.44 454.263 460.74C-19.616 134.581 -1308.04 415.365 -1893.01 596.527",
    stroke: "url(#paint6_linear_1229_42283)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3372.75 1.07872C1730.75 242.326 1003.07 815.126 459.272 383.441C24.2343 38.0927 -1265.13 286.368 -1855.43 453.675",
    stroke: "url(#paint7_linear_1229_42283)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3366.26 37.6934C1764.11 560.437 1344.91 1174.68 494.958 927.7C-185.005 730.113 -1406.35 1188.91 -1932.03 1443.01",
    stroke: "url(#paint8_linear_1229_42283)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3369.99 37.3031C1751.85 525.088 1287.81 1137.73 474.02 863.918C-177.009 644.871 -1415.68 1077.97 -1953.64 1321.9",
    stroke: "url(#paint9_linear_1229_42283)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3366.56 36.8222C1733.04 479.601 1214.34 1088.5 447.988 781.991C-165.092 536.783 -1421.88 936.588 -1973.64 1167.14",
    stroke: "url(#paint10_linear_1229_42283)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3356.77 37.4548C1714.13 440.48 1149.81 1044.64 426.107 710.823C-152.852 443.766 -1422.05 813.982 -1984.28 1032.47",
    stroke: "url(#paint11_linear_1229_42283)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3378.69 32.3323C1732.81 414.272 1145.23 1015.41 444.416 667.667C-116.231 389.47 -1390.73 743.928 -1957.9 955.931",
    stroke: "url(#paint12_linear_1229_42283)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3382.24 32.3128C1733.15 375.89 1104.83 970.676 446.116 598.536C-80.8564 300.824 -1362.85 626.503 -1937.97 826.556",
    stroke: "url(#paint13_linear_1229_42283)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3379.24 31.4509C1730.79 326.184 1053.41 911.355 449.091 509.827C-34.3682 188.604 -1322.08 477.447 -1905.51 662.022",
    stroke: "url(#paint14_linear_1229_42283)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3370.02 31.0956C1726.25 283.15 1008.46 858.6 452.354 432.843C7.46973 92.237 -1281.93 348.729 -1871.03 519.55",
    stroke: "url(#paint15_linear_1229_42283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1229_42283",
    x1: 682.328,
    y1: 568.919,
    x2: 799.032,
    y2: 1004.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1229_42283",
    x1: 685.984,
    y1: 505.092,
    x2: 792.732,
    y2: 942.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1229_42283",
    x1: 690.208,
    y1: 423.805,
    x2: 784.877,
    y2: 865.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1229_42283",
    x1: 693.711,
    y1: 353.972,
    x2: 777.966,
    y2: 799.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1229_42283",
    x1: 725.016,
    y1: 311.975,
    x2: 803.798,
    y2: 760.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1229_42283",
    x1: 749.487,
    y1: 245.225,
    x2: 818.329,
    y2: 698.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1229_42283",
    x1: 780.09,
    y1: 160.338,
    x2: 836.178,
    y2: 619.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1229_42283",
    x1: 806.27,
    y1: 87.3959,
    x2: 850.98,
    y2: 553.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1229_42283",
    x1: 680.558,
    y1: 615.986,
    x2: 799.662,
    y2: 1049.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1229_42283",
    x1: 682.861,
    y1: 552.288,
    x2: 792.217,
    y2: 988.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1229_42283",
    x1: 685.243,
    y1: 471.347,
    x2: 782.515,
    y2: 912.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1229_42283",
    x1: 687.164,
    y1: 401.804,
    x2: 774.042,
    y2: 846.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1229_42283",
    x1: 717.637,
    y1: 359.779,
    x2: 799.062,
    y2: 806.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1229_42283",
    x1: 740.693,
    y1: 293.156,
    x2: 812.228,
    y2: 744.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1229_42283",
    x1: 769.484,
    y1: 208.439,
    x2: 828.36,
    y2: 666.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1229_42283",
    x1: 794.113,
    y1: 135.639,
    x2: 841.722,
    y2: 599.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpElement05);
export default __webpack_public_path__ + "static/media/hp_element_05.c841b93b5e63cd07d804a9a2b5aa8587.svg";
export { ForwardRef as ReactComponent };